module.exports = __webpack_public_path__ + "img/1009e_1.94b42158.jpg";